import { Directive, ElementRef, HostListener, OnDestroy, OnInit, Renderer2 } from "@angular/core"

@Directive({
  selector: "img[agImageLoader]",
  standalone: false,
})
export class ImageLoaderDirective implements OnInit, OnDestroy {
  private readonly loadingClass = "img-loading"
  private observer: MutationObserver

  constructor(
    private el: ElementRef<HTMLImageElement>,
    private renderer: Renderer2,
  ) {}

  ngOnInit(): void {
    this.updateLoadingState()
    this.observer = new MutationObserver(() => this.updateLoadingState())
    this.observer.observe(this.el.nativeElement, { attributes: true, attributeFilter: ["src"] })
  }

  ngOnDestroy(): void {
    this.observer?.disconnect()
  }

  @HostListener("load")
  @HostListener("error")
  onSettled(): void {
    this.renderer.removeClass(this.el.nativeElement, this.loadingClass)
  }

  private updateLoadingState(): void {
    const img = this.el.nativeElement
    if (img.getAttribute("src") && !img.complete) this.renderer.addClass(img, this.loadingClass)
    else this.renderer.removeClass(img, this.loadingClass)
  }
}
